<div [formGroup]="this.formGroup">
    <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{field.label}}</mat-label>
        <input (click)="picker.open()" matInput [matDatepicker]="picker" [formControlName]="this.fieldKey">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>